import { render, staticRenderFns } from "./LicenseOne.vue?vue&type=template&id=53d68ca2"
import script from "./LicenseOne.vue?vue&type=script&lang=js"
export * from "./LicenseOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports